// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NewCorePricingSidebar from "./create-core-pricing/NewCorePricingSidebar.bs.js";
import * as CorePricingDetailSidebar from "./core-pricing/CorePricingDetailSidebar.bs.js";

function getSidebar(sidebar, updateState) {
  if (sidebar.TAG === /* CampaignDetails */0) {
    return React.createElement(CorePricingDetailSidebar.make, {
                campaign: sidebar._0,
                role: sidebar._1,
                closeSidebar: (function (param) {
                    return Curry._1(updateState, (function (param) {
                                  
                                }));
                  })
              });
  } else {
    return React.createElement(NewCorePricingSidebar.make, {
                active_campaign: sidebar._0,
                campaigns: sidebar._1,
                closeSidebar: (function (param) {
                    return Curry._1(updateState, (function (param) {
                                  
                                }));
                  })
              });
  }
}

function useSidebar(param) {
  var match = React.useState(function () {
        
      });
  var updateState = match[1];
  var state = match[0];
  var sidebarComp = state !== undefined ? getSidebar(state, updateState) : null;
  return [
          sidebarComp,
          updateState
        ];
}

export {
  useSidebar ,
  
}
/* react Not a pure module */
